import {ForwardedRef, forwardRef} from 'react';
import {InputProps} from 'react-html-props';
import './qep-input.scss';

export type QEPInputProps = InputProps & {
  testId?: string;
  allowSpecialCharacters?: boolean;
};

export const QEPInput = forwardRef(function QEPInput({
  'data-testid': dataTestIdProp,
  allowSpecialCharacters = true,
  className,
  disabled = false,
  maxLength,
  onKeyDown,
  testId,
  type = 'text',
  ...props
}: QEPInputProps, ref: ForwardedRef<HTMLInputElement>) {
  const dataTestId = dataTestIdProp ?? testId ?? 'qep-input';

  return (
    <input
      {...props}
      className={`qep-input ${className ?? ''}`}
      data-testid={dataTestId}
      disabled={disabled}
      maxLength={maxLength}
      ref={ref}
      type={type}
      onKeyDown={e => {
        const isPrintableChar = e.key.length === 1;
        const isAlphaNumericOrSpace = new RegExp(/^[\u0020-\u007E]+$/gi).test(e.key);

        if (!allowSpecialCharacters && isPrintableChar && !isAlphaNumericOrSpace) {
          e.preventDefault();
        }

        onKeyDown?.(e);
      }}
    />
  );
});
